<!-- src/components/SkeletonLoader.vue -->
<template>
    <div class="skeleton-loader" :style="style"></div>
  </template>
  
  <script>
  export default {
    props: {
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '20px'
      }
    },
    computed: {
      style() {
        return {
          width: this.width,
          height: this.height,
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          margin: '10px 0'
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .skeleton-loader {
    animation: pulse 1.5s infinite ease-in-out;
  }
  
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  </style>
  